export class ICDCodeService {
    concept = null;
    service = null;
    note = null;
}